module.exports = __webpack_public_path__ + "static/media/Header-Image.ca689d59.webp";